export default "__VITE_ASSET__DWmnLtvW__"